<template>
  <div class='ct-flex-center page-login'>
    <slot />
    <div class="version">VERSION {{ version }}</div>
    <div class='logo flex items-center space-between'>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
</template>

<script>

export default {
  name: 'main-page',
  computed: {
    version () {
      return process.env.VUE_APP_VERSION
    }
  }
}
</script>
